export const Skills = [
    {
        key: 'software',
        label: 'Software Developer',
        title: 'Software Developer',
        tagline: 'Full-stack systems, from interface to infrastructure',
        summary:
            'I build responsive, high-performance interfaces and robust backends designed to scale, secure data, and handle real-world complexity.',
        groups: [
            {
                title: 'Frontend',
                items: ['React.js', 'TypeScript', 'Next.js', 'Framer Motion', 'Accessibility', 'Performance'],
            },
            {
                title: 'Backend',
                items: ['Node.js (Express)', 'TypeScript', 'Python (Flask, FastAPI)', 'REST', 'GraphQL', 'Auth & security'],
            },
            {
                title: 'Databases',
                items: ['MySQL', 'PostgreSQL', 'MongoDB', 'SQLite', 'Prisma', 'Sequelize', 'Mongoose', 'Zod'],
            },
            {
                title: 'Bots & Messaging',
                items: ['Telegram bots', 'WhatsApp bots', 'Customer support agents', 'E-commerce agents'],
            },
            {
                title: 'Deployment & DevOps',
                items: ['AWS', 'Google Cloud', 'Render', 'Railway', 'Hostinger', 'Docker', 'GitHub Actions', 'Nginx', 'PM2', 'Linux CLI', 'HTTPS & domains'],
            },
            {
                title: 'Desktop (secondary)',
                items: ['WinForms', '.NET MAUI', 'C#'],
            },
        ],
        tools: ['VS Code', 'Git', 'GitHub', 'Postman', 'Figma', 'Chrome DevTools', 'JWT', 'Claude Code'],
    },
    {
        key: 'embedded',
        label: 'Embedded AI',
        title: 'Embedded AI',
        tagline: 'Software, hardware, and intelligence that responds to the real world',
        summary:
            'I explore the intersection of software, hardware, and intelligence, building systems that do more than run: they respond to their environment.',
        groups: [
            {
                title: 'Hardware',
                items: ['Raspberry Pi', 'Arduino', 'ESP', 'GPIO interfacing', 'Sensors & components', 'Electrical experiments'],
            },
            {
                title: 'AI on the edge',
                items: ['Computer Vision', 'OpenCV', 'Python', 'Basic ML libraries'],
            },
            {
                title: 'Firmware',
                items: ['C / C++', 'Microcontrollers', 'Input-response systems', 'Automation',  'ROS2'],
            },
        ],
        tools: ['Arduino IDE', 'VS Code', 'Linux', 'Hardware-software integration'],
    },
    {
        key: 'automation',
        label: 'AI Automation',
        title: 'AI Automation',
        tagline: 'Workflows that run the boring parts on their own',
        // EDIT: draft copy, adjust to your real experience
        summary:
            'I design automation pipelines with n8n as my primary tool, connecting APIs, data sources, and AI models into workflows that save real time.',
        groups: [
            {
                title: 'Workflow Automation',
                items: ['n8n', 'Webhooks & triggers', 'Scheduled jobs', 'Error handling & retries'],
            },
            {
                title: 'AI Integration',
                items: ['LLM-powered agents', 'Prompt chaining', 'Telegram & WhatsApp agents', 'Data extraction'],
            },
            {
                title: 'Integrations',
                items: ['REST APIs', 'Google Sheets', 'Email', 'Databases', 'CRMs'],
            },
        ],
        tools: ['n8n', 'Webhooks', 'JSON', 'REST', 'Python scripting', 'LangChain', 'Claude Code', 'OpenAI API', 'Google APIs'],
    },
    {
        key: 'research',
        label: 'Research',
        title: 'Research',
        tagline: 'Asking sharp questions and backing answers with evidence',
        // EDIT: placeholders, replace with your actual research skills and field
        summary:
            'I carry out research from question to result: reviewing literature, designing experiments, and communicating findings clearly.',
        groups: [
            {
                title: 'Method',
                items: ['Literature review', 'Experiment design', 'Data collection', 'Data analysis'],
            },
            {
                title: 'Communication',
                items: ['Technical writing', 'Paper drafting', 'Presenting findings'],
            },
            {
                title: 'Reproducibility',
                items: ['Git', 'Jupyter notebooks', 'Documented pipelines'],
            },
        ],
        tools: ['LaTeX', 'Python', 'Zotero'],
    },
];